import {
  FETCH_MANUFACTURERS,
  FETCH_MANUFACTURERS_FULFILLED,
  FETCH_MANUFACTURERS_REJECTED,
} from 'b2b-apps/shop/manufacturer/redux/manufacturers/actionTypes';
import {
  FetchManufacturersAction,
  FetchManufacturersFulfilledAction,
  FetchManufacturersRejectedAction,
  ManufacturersType,
} from 'b2b-apps/shop/manufacturer/redux/manufacturers/types';

const fetchManufacturers = (
  query?: string,
  filter?: string,
): FetchManufacturersAction => ({
  type: FETCH_MANUFACTURERS,
  payload: {
    filter,
    query,
  },
});

const fetchManufacturersFulfilled = (
  response: ManufacturersType,
): FetchManufacturersFulfilledAction => ({
  type: FETCH_MANUFACTURERS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchManufacturersRejected = (
  error: ErrorType,
): FetchManufacturersRejectedAction => ({
  type: FETCH_MANUFACTURERS_REJECTED,
  payload: {
    error,
  },
});

export {
  fetchManufacturers,
  fetchManufacturersFulfilled,
  fetchManufacturersRejected,
};
